import styled from "@emotion/styled";
import BaseContainer from "components/Containers/BaseContainer";
import Text from "components/Text";
import { FormattedMessage } from "react-intl";

import { memo, useMemo } from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import WidgetComponent from "@power-rent/widget";
import messages from "../../../store/messages";
import Cars from "./Cars";

type Props = {
  widgetId: string;
};

const FleetSection = ({ widgetId }: Props) => {
  const Widget = useMemo(() => styled.div`
    width: 100%;
    min-height: 200px;
  `, []);

  return (
    <BaseContainer marginTop="2vh">
      <Widget>
        <WidgetComponent
          key={widgetId}
          widgetId={widgetId}
          dev={process.env.NODE_ENV === "development"}
          alwaysOpened
        />
      </Widget>
      <Text tag="h1" variant="h1">
        <FormattedMessage {...messages.fleetType} />
      </Text>
      <Cars />
    </BaseContainer>
  );
};

export default memo(FleetSection);
